import { h } from "preact";
import classname from "../../foundation/utils/classname";

import "./style.css";

interface Props {
    class?: string;
}

export default function LoadingOverlay({ class: cssClass }: Props) {
    return (
        <div class={classname("loadingOverlay", cssClass)}>
            <div class="ripple ripple1"></div>
            <div class="ripple ripple2"></div>
            <div class="ripple ripple3"></div>
            <div class="ripple ripple4"></div>
        </div>
    );
}
